import { environment } from 'src/environments/environment.development';
import { iModulesList } from './Interfaces/modules-list';

export const ModulesList: iModulesList[] = [
  // HR360
  {
    section: 'HR360',
    icon: '/assets/images/logo/360.png',
    iconDark: '/assets/images/logo/360.dark.png',
    menu: '',
    renderIf: {
      roles: ['employee'],
      right: '',
    },
    children: [
      {
        title: 'Dashboard',
        icon: '/assets/images/icons/home/dashboard.svg',
        link: '/dashboard',
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'R',
        },
      },
      {
        title: 'My Profile',
        icon: '/assets/images/icons/home/profile.svg',
        link: '/app/profile',
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'K',
        },
      },
      {
        title: 'HR360',
        icon: '/assets/images/icons/home/hr360.svg',
        link: '/hr360',
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'F',
        },
      },
    ],
  },
  //iNest
  {
    section: 'iNest',
    icon: '/assets/images/logo/i-nest.svg',
    iconDark: '/assets/images/logo/i-nest.svg',
    menu: '',
    renderIf: {
      roles: ['employee'],
      right: '',
    },
    children: [
      {
        title: 'iNest',
        icon: '/assets/images/icons/home/i-nest.svg',
        link: '/i-nest',
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'N',
        },
      },
    ],
  },
  // iTeam
  {
    section: 'iTeam',
    icon: '/assets/images/logo/logo.png',
    iconDark: '/assets/images/logo/logo.png',
    menu: '',
    renderIf: {
      roles: ['employee', 'customer'],
      right: '',
    },
    children: [
      {
        title: 'iTeam',
        icon: '/assets/images/icons/home/i-team.svg',
        link: '/i-team/',
        external: true,
        renderIf: {
          roles: ['employee', 'customer'],
          right: 'H',
        },
      },
    ],
  },
  // SQA
  {
    section: 'SQA',
    icon: '/assets/images/icons/home/sqa.svg',
    iconDark: '/assets/images/icons/home/sqa.svg',
    menu: '',
    renderIf: {
      roles: ['employee'],
      right: '',
    },
    children: [
      {
        title: 'SQA',
        icon: '/assets/images/icons/home/sqa.svg',
        link: `${environment.sqa_url}/`,
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'O',
        },
      },
    ],
  },
  // CRM
  {
    section: 'CRM',
    icon: '/assets/images/logo/LK.png',
    iconDark: '/assets/images/logo/LK.dark.png',
    menu: '',
    renderIf: {
      roles: ['employee', 'customer'],
      right: '',
    },
    children: [
      {
        title: 'Lead Konnekt',
        icon: '/assets/images/icons/home/lead-konnekt.svg',
        link: '/lead-konnekt',
        external: true,
        renderIf: {
          roles: ['employee', 'customer'],
          right: 'I',
        },
      },
    ],
  },
  // Meetings
  {
    section: 'Meetings',
    icon: '/assets/images/icons/home/meetings.svg',
    iconDark: '/assets/images/icons/home/meetings.svg',
    menu: '',
    renderIf: {
      roles: ['employee'],
      right: '',
    },
    children: [
      {
        title: 'Meetings',
        icon: '/assets/images/icons/home/meetings.svg',
        link: '/app/meetings',
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'J',
        },
      },
    ],
  },
  // Forms
  {
    section: 'Forms',
    icon: '/assets/images/logo/easyform.png',
    iconDark: '/assets/images/logo/easyform.dark.png',
    menu: '',
    renderIf: {
      roles: ['employee'],
      right: '',
    },
    children: [
      {
        title: 'Easy Forms',
        icon: '/assets/images/icons/home/easy-form.svg',
        link: `${environment.easy_form_url}/app/form-approvals`,
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'E',
        },
      },
    ],
  },
  // Education
  {
    section: 'Education',
    menu: '',
    iconDark: '',
    renderIf: {
      roles: ['employee'],
      right: '',
    },
    children: [
      {
        title: 'My Class',
        icon: '/assets/images/icons/home/my-class.png',
        link: `${environment.easy_fee_url}`,
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'D',
          departments: ['Academics'],
        },
      },
      {
        title: 'Easy Fee',
        icon: '/assets/images/icons/home/easy-fee-dark.svg',
        iconDark: '/assets/images/icons/home/easy-fee-light.svg',
        link: `${environment.easy_fee_url}`,
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'D',
          excludeDepartments: ['Academics'],
        },
      },
      {
        title: 'iSchool',
        icon: '/assets/images/icons/home/ischool-dark.svg',
        iconDark: '/assets/images/icons/home/ischool-light.svg',
        link: `${environment.ischool_url}`,
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'G',
        },
      },
    ],
  },
  // Accounting
  {
    section: 'Easy Accounts',
    icon: '/assets/images/icons/home/accounting.svg',
    iconDark: '/assets/images/icons/home/accounting.svg',
    menu: '',
    renderIf: {
      roles: ['employee'],
      right: '',
    },
    children: [
      {
        title: 'Easy Accounts',
        icon: '/assets/images/icons/home/accounting.svg',
        link: `${environment.accounting_url}/`,
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'C',
        },
      },
    ],
  },
  //Invoicing
  {
    section: 'Easy Invoice',
    icon: '/assets/images/logo/logo.png',
    iconDark: '/assets/images/logo/logo.png',
    menu: '',
    renderIf: {
      roles: ['employee'],
      right: '',
    },
    children: [
      {
        title: 'Easy Invoice',
        icon: '/assets/images/icons/home/easy-invoice.svg',
        link: '/invoicing/',
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'P',
        },
      },
    ],
  },
  // Inventory
  {
    section: 'Asset Pro',
    icon: '/assets/images/icons/home/inventory.svg',
    iconDark: '/assets/images/icons/home/inventory.svg',
    menu: '',
    renderIf: {
      roles: ['employee'],
      right: '',
    },
    children: [
      {
        title: 'Asset Pro',
        icon: '/assets/images/icons/home/inventory.svg',
        link: `${environment.inventory_url}/`,
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'A',
        },
      },
    ],
  },
  // Support
  {
    section: 'Support',
    withText: true,
    renderIf: {
      roles: ['employee'],
      right: '',
    },
    icon: '',
    iconDark: '',
    menu: '',
    children: [
      {
        title: 'Support',
        icon: '/assets/images/icons/home/support.svg',
        link: '/app/support',
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'M',
        },
      },
    ],
  },
  // Setup
  {
    section: 'Setup',
    withText: true,
    icon: '/assets/images/logo/settings.svg',
    iconDark: '/assets/images/logo/settings.svg',
    menu: '',
    renderIf: {
      roles: ['employee'],
      right: '',
    },
    children: [
      {
        title: 'Setup',
        icon: '/assets/images/icons/home/settings.svg',
        link: '/setup',
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'L',
        },
      },
    ],
  },
  // Movement Diary
  {
    section: 'Movement Diary',
    icon: '/assets/images/icons/home/movement Diary (Nine Icon).svg',
    iconDark: '/assets/images/icons/home/movement Diary (Nine Icon).svg',
    menu: 'movementDiary',
    renderIf: {
      roles: ['employee'],
      right: '',
    },
    children: [
      {
        title: 'Movement Diary',
        icon: '/assets/images/icons/home/movement Diary (Nine Icon).svg',
        link: '/movement-diary',
        external: true,
        renderIf: {
          roles: ['employee'],
          right: 'Q',
        },
      },
    ],
  },
];
